(function () { 
  if (document.getElementsByTagName('body')[0].classList.contains('has-piwik')) {
    initVideoIfMarketingCookiesAccepted(initVideoPlayers);
  }
  else {
    initVideoPlayers();
  }

  function initVideoPlayers() {
    var videoPlayers = document.querySelectorAll('.youtube-video');
    if (videoPlayers && videoPlayers.length > 0) {
      Array.prototype.slice.call(videoPlayers)
        .forEach(function (videoBlockEl) {
          initializeVideoYoutubeControls(videoBlockEl);
        });
    }
  }
})();